import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Input } from "reactstrap";
import axios from "axios";

import { withTranslation } from "react-i18next";

const DateFormatPicker = ({ t, allowNone, className, id, onChange, size }) => {
  const [dateFormats, setdateFormats] = useState([]);

  useEffect(() => {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    load(source);
    return () => {
      source.cancel("Cancel");
    };
  }, [id]);

  const load = async (source) => {
    try {
      const res = await axios({
        url: `api/user/date-format`,
        cancelToken: source.token,
        method: "GET",
      });
      setdateFormats(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div>
      <Input
        type="select"
        bsSize={size || "md"}
        value={id}
        onChange={onChange}
        className={className || ""}
      >
        {(id === 0 || allowNone) && (
          <option value={0}>{t("DateFormatPicker.chooseDateFormat")}</option>
        )}
        {dateFormats.map((dateFormat) => (
          <option key={dateFormat.dateFormat} value={dateFormat.dateFormat}>
            {dateFormat.mask}
          </option>
        ))}
      </Input>
    </div>
  );
};

DateFormatPicker.propTypes = {
  allowNone: PropTypes.bool,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  onChange: PropTypes.func,
  size: PropTypes.string,
  t: PropTypes.func,
};

export default withTranslation()(DateFormatPicker);
